import { actionTypes } from "../actions";

const initialState = {
  userInfo: {
    userId: "",
    countrySk: "",
    principalName: "",
    userGroups: null,
    EmployeeFirstName: "",
    EmployeeLastName: "",
    EmployeeEmail: "",
    countryCode: "",
  },
  countries: [],
  isCountryChanged: false,
  loading: false,
  redirect: false,
  isFilterSet: false,
  isUpdated: false,
  alertStatus: false,
  message: "",
  alertType: "",
  isUserAvailable: true,
  isCountryAvailable: false,
  isError: false,
  ezds: [],
  loader: false,
  showToast: false,
  dynamicToastValue: { value: "" } 
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_USER_INFO:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...payload,
        },
      };

    case actionTypes.SET_COUNTRIES:
      return {
        ...state,
        countries: payload,
      };

    case actionTypes.SET_ERROR:
      return {
        ...state,
        isError: payload,
      };

    case actionTypes.SET_ERROR_MESSAGE:
      return {
        ...state,
        message: payload,
      };

    case actionTypes.SET_COUNTRY_NAME:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          countryCode: payload,
        },
      };

    case actionTypes.SET_COUNTRY_SK:
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          countrySk: payload,
        },
      };

    case actionTypes.SET_COUNTRY_CHANGED:
      return {
        ...state,
        isCountryChanged: payload,
      };

    case actionTypes.SET_USER_AVAILABILITY:
      return {
        ...state,
        isUserAvailable: payload,
      };

    case actionTypes.SET_COUNTRY_AVAILABILITY:
      return {
        ...state,
        isCountryAvailable: payload,
      };

    case actionTypes.SET_LOADING:
      return {
        ...state,
        loading: payload,
      };

    case actionTypes.SET_LOADER:
      return {
        ...state,
        loader: payload,
      };

    case actionTypes.SET_REDIRECT:
      return {
        ...state,
        redirect: payload,
      };

    case actionTypes.CLEAR_FILTER:
      return {
        ...state,
        isFilterSet: payload,
      };

    case actionTypes.SET_UPDATED:
      return {
        ...state,
        isUpdated: payload,
      };
    case actionTypes.SET_ALERT:
      return {
        ...state,
        ...payload,
      };

    case actionTypes.SET_EZDS:
      return {
        ...state,
        ezds: payload,
      };

    case actionTypes.HIDE_TOAST:
      return {
        ...state,
        message: "",
        alertType: "",
        showToast: false,
      }

    default:
      return {
        ...state,
      };
  }
};
